export interface Testimonial {
  id: string;
  name: string;
  role: string;
  avatar: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: "t-1",
    name: "张先生",
    role: "资深足球爱好者",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20male%20sports%20fan%20portrait%20professional%20headshot%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20lighting%2C%20friendly%20expression&width=120&height=120&seq=avatar-zhang&orientation=squarish",
    content: "开体育在线是我每天必看的体育平台。赛事直播速度快、画质清晰，资讯更新也非常及时。特别是西甲的直播，解说专业、数据详实，比很多平台都强！",
    rating: 5,
  },
  {
    id: "t-2",
    name: "李女士",
    role: "篮球迷 & 电竞爱好者",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20female%20sports%20fan%20portrait%20professional%20headshot%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20lighting%2C%20friendly%20expression&width=120&height=120&seq=avatar-li&orientation=squarish",
    content: "作为女生，我特别喜欢开体育在线的界面设计，简洁清晰不杂乱。NBA和电竞赛事都能在一个平台看，不用来回切换，太方便了。",
    rating: 5,
  },
  {
    id: "t-3",
    name: "王教练",
    role: "青训足球教练",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20male%20sports%20coach%20portrait%20professional%20headshot%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20lighting%2C%20confident%20expression&width=120&height=120&seq=avatar-wang&orientation=squarish",
    content: "作为青训教练，我经常用开体育在线的数据功能给学员做战术分析。数据维度丰富、可视化效果好，是教学的好帮手。",
    rating: 4,
  },
  {
    id: "t-4",
    name: "赵经理",
    role: "体育营销总监",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20female%20business%20professional%20portrait%20headshot%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20lighting%2C%20professional%20expression&width=120&height=120&seq=avatar-zhao&orientation=squarish",
    content: "开体育在线的赛事覆盖范围很广，从主流联赛到小众赛事都能找到。我们做市场调研经常参考他们的数据，非常靠谱。",
    rating: 5,
  },
  {
    id: "t-5",
    name: "陈同学",
    role: "大学生体育爱好者",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20male%20young%20college%20student%20portrait%20headshot%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20lighting%2C%20energetic%20expression&width=120&height=120&seq=avatar-chen&orientation=squarish",
    content: "课间休息就打开体育在线看比赛回放和集锦，加载速度很快，宿舍网速也能流畅观看。同学们都在用，已经成为我们的生活一部分了。",
    rating: 5,
  },
];